const stockEn = {
  navigation: { stock: 'Stock' },
  roles: { modal: { form: { categories: { stock: 'Stock' } } } },
  dashboard: {
    kpis: {
      lowStock: 'Low stock',
      negativeStock: 'Negative stock',
      stockValue: 'Stock value',
    },
  },
  productsManagement: {
    emptyHint: 'Record a purchase to add your first product to stock.',
    actions: {
      purchaseMore: 'Purchase more',
    },
    fields: {
      soldToCustomers: 'Sold to customers',
      soldToCustomersHelp: 'Turn this off for products used only inside the store. They have no customer price.',
      contentQuantity: 'Amount in each package',
      stockUnit: 'Unit',
      contentLocked: 'The package size is locked because this product already has stock movements.',
      lowStockThreshold: 'Low stock warning',
      lowStockHelp: 'Enter how many packages should trigger a low-stock warning.',
      onHand: 'On hand',
      stockIncreasesOnPurchase: 'Stock increases only when a purchase is recorded.',
      lastCost: 'Last cost {{cost}} on {{date}}',
      noCostYet: 'No purchase cost yet.',
    },
    units: {
      Unit: 'Unit',
      Milliliter: 'Millilitre',
      Gram: 'Gram',
    },
    card: {
      internalUse: 'Internal use',
      onHand: 'On hand: {{quantity}}',
    },
    sale: {
      onlyNLeft: 'Only {{count}} left',
    },
    validation: {
      contentRequired: 'Package content must be greater than 0.',
      unitRequired: 'Choose a unit.',
      lowStockInvalid: 'Low stock warning cannot be negative.',
    },
  },
  stock: {
    title: 'Stock',
    subtitle: 'Purchases, movements and suppliers',
    tabs: {
      overview: 'Stock',
      stock: 'Stock',
      purchases: 'Purchases',
      movements: 'Movements',
      adjustments: 'Adjustments',
      suppliers: 'Suppliers',
    },
    fallback: {
      message: 'Select a store to manage stock.',
      subtitle: 'Select a store to manage stock',
      goToStores: 'Go to stores',
    },
    summary: {
      low: 'Low stock',
      negative: 'Negative stock',
      value: 'Estimated stock value',
    },
    status: {
      ok: 'In stock',
      low: 'Low',
      out: 'Out of stock',
      negative: 'Negative',
    },
    overview: {
      search: 'Search products',
      product: 'Product',
      onHand: 'On hand',
      status: 'Status',
      lastCost: 'Last cost',
      noCost: '—',
      empty: 'No products to show.',
    },
    purchases: {
      record: 'Record purchase',
      recordTitle: 'Record purchase',
      detailsTitle: 'Purchase',
      date: 'Date',
      supplier: 'Supplier',
      newSupplier: 'New supplier',
      noSupplier: 'No supplier',
      invoice: 'Invoice reference',
      paymentMethod: 'Payment method',
      vatAmount: 'VAT amount',
      vatRate: 'VAT rate (%)',
      vatRateHelp: 'Included in the package cost.',
      notes: 'Notes',
      lines: 'Lines',
      product: 'Product',
      newProduct: 'New product',
      newProductName: 'Product name',
      packageQuantity: 'Packages received',
      unitCost: 'Cost per package',
      total: 'Total',
      addLine: 'Add line',
      removeLine: 'Remove line',
      status: 'Status',
      view: 'View',
      void: 'Void purchase',
      voidTitle: 'Void this purchase?',
      voidMessage: 'Stock and the linked expense are reversed. This cannot be undone.',
      voidReason: 'Voided from stock',
      voided: 'Purchase voided.',
      saved: 'Purchase recorded.',
      empty: 'No purchases yet.',
      negativeWarning: 'These products are now negative: {{products}}',
    },
    purchaseStatus: {
      Recorded: 'Recorded',
      Voided: 'Voided',
    },
    movements: {
      type: 'Type',
      allTypes: 'All types',
      when: 'When',
      product: 'Product',
      delta: 'Change',
      balance: 'Balance',
      cost: 'Unit cost',
      empty: 'No movements yet.',
    },
    movementTypes: {
      OpeningBalance: 'Opening balance',
      Purchase: 'Purchase',
      PurchaseVoid: 'Purchase void',
      Sale: 'Sale',
      SaleVoid: 'Sale void',
      ServiceConsumption: 'Service use',
      ServiceConsumptionReversal: 'Service use reversed',
      Adjustment: 'Adjustment',
    },
    adjustments: {
      title: 'Remove stock',
      intro: 'Corrections only remove stock. To add stock, record a purchase.',
      open: 'Record a decrease',
      save: 'Remove stock',
      saved: 'Stock updated.',
      decreaseOnly: 'You can remove quantity, or enter a count that does not exceed what is on hand.',
      product: 'Product',
      reason: 'Reason',
      removed: 'Quantity removed',
      removedHelp: 'Packages taken out of stock. This cannot add stock.',
      counted: 'Counted packages',
      countedHelp: 'On hand: {{onHand}}. A higher count is not allowed.',
      amountReturned: 'Amount returned',
      amountReturnedHelp: 'Enter 0 if the supplier paid nothing back. A higher amount lowers today’s inventory expenses by that amount.',
      refundPaymentMethod: 'How it was returned',
      notes: 'Notes',
    },
    reasons: {
      CountCorrection: 'Count correction',
      Damaged: 'Damaged',
      Expired: 'Expired',
      InternalUse: 'Internal use',
      Lost: 'Lost',
      ReturnedToSupplier: 'Returned to supplier',
      Other: 'Other',
    },
    suppliers: {
      create: 'Add supplier',
      createTitle: 'New supplier',
      editTitle: 'Edit supplier',
      edit: 'Edit',
      name: 'Name',
      taxId: 'Tax ID',
      phone: 'Phone',
      email: 'Email',
      notes: 'Notes',
      empty: 'No suppliers yet.',
      saved: 'Supplier saved.',
      archive: 'Archive',
      archiveTitle: 'Archive supplier?',
      archiveMessage: 'Archive {{name}}? They stay on past purchases.',
      archived: 'Supplier archived.',
      validation: { nameRequired: 'Supplier name is required.' },
    },
    validation: {
      productRequired: 'Choose a product.',
      reasonRequired: 'Choose a reason.',
      countInvalid: 'Enter the counted quantity.',
      countExceedsOnHand: 'The count cannot be higher than the stock on hand.',
      countUnchanged: 'That count matches the stock on hand.',
      quantityRemovedRequired: 'Enter the quantity removed.',
      quantityExceedsOnHand: 'You cannot remove more than the stock on hand.',
      amountReturnedInvalid: 'Enter 0 or the amount the supplier paid back.',
      linesRequired: 'Add between 1 and 100 lines.',
      duplicateProduct: 'Each product can appear only once.',
      quantityRequired: 'Quantity must be greater than 0.',
      costRequired: 'Enter a cost of 0 or more.',
      dateRequired: 'Choose a date.',
      dateInFuture: 'The date cannot be in the future.',
      paymentMethodRequired: 'Choose an in-store payment method.',
      vatInvalid: 'VAT amount cannot be negative.',
      vatRateRequired: 'Enter a VAT rate from 0 to 100.',
    },
    errors: {
      load: 'Could not load stock.',
      adjust: 'Could not update stock.',
      purchase: 'Could not record the purchase.',
      voidPurchase: 'Could not void the purchase.',
      supplier: 'Could not save the supplier.',
      insufficient: 'There is not enough stock.',
      onlyNLeft: 'Only {{count}} left.',
      notSellable: 'This product is not sold to customers.',
      unitLocked: 'The unit cannot change after stock movements exist.',
      purchaseNotFound: 'Purchase not found.',
      purchaseVoided: 'This purchase is already voided.',
      supplierNotFound: 'Supplier not found.',
      supplierArchived: 'This supplier is archived.',
      recipeInvalid: 'The service recipe is not valid.',
    },
    recipe: {
      title: 'Products used',
      product: 'Product',
      quantity: 'Quantity',
      add: 'Add',
      remove: 'Remove product',
      totalCost: 'Estimated product cost {{cost}}',
      costMissing: 'Product cost is incomplete until every line has a purchase cost.',
      margin: 'Margin after products {{amount}}',
    },
    usage: {
      title: 'Products used',
      help: 'Prefilled from the service recipe. Set a quantity to 0 to skip a product.',
      toggle: 'Show or hide products used',
    },
  },
};

const stockPt = {
  navigation: { stock: 'Stock' },
  roles: { modal: { form: { categories: { stock: 'Stock' } } } },
  dashboard: {
    kpis: {
      lowStock: 'Stock baixo',
      negativeStock: 'Stock negativo',
      stockValue: 'Valor do stock',
    },
  },
  productsManagement: {
    emptyHint: 'Registe uma compra para adicionar o primeiro produto ao stock.',
    actions: {
      purchaseMore: 'Comprar mais',
    },
    fields: {
      soldToCustomers: 'Vendido a clientes',
      soldToCustomersHelp: 'Desligue para produtos só de uso interno. Não têm preço para o cliente.',
      contentQuantity: 'Quantidade em cada embalagem',
      stockUnit: 'Unidade',
      contentLocked: 'O tamanho da embalagem fica bloqueado porque este produto já tem movimentos de stock.',
      lowStockThreshold: 'Aviso de stock baixo',
      lowStockHelp: 'Indique quantas embalagens disparam o aviso.',
      onHand: 'Em stock',
      stockIncreasesOnPurchase: 'O stock só aumenta quando se regista uma compra.',
      lastCost: 'Último custo {{cost}} em {{date}}',
      noCostYet: 'Ainda sem custo de compra.',
    },
    units: { Unit: 'Unidade', Milliliter: 'Mililitro', Gram: 'Grama' },
    card: { internalUse: 'Uso interno', onHand: 'Em stock: {{quantity}}' },
    sale: { onlyNLeft: 'Só restam {{count}}' },
    validation: {
      contentRequired: 'O conteúdo da embalagem tem de ser maior que 0.',
      unitRequired: 'Escolha uma unidade.',
      lowStockInvalid: 'O aviso de stock baixo não pode ser negativo.',
    },
  },
  stock: {
    title: 'Stock',
    subtitle: 'Compras, movimentos e fornecedores',
    tabs: {
      overview: 'Stock',
      stock: 'Stock',
      purchases: 'Compras',
      movements: 'Movimentos',
      adjustments: 'Ajustes',
      suppliers: 'Fornecedores',
    },
    fallback: {
      message: 'Selecione uma loja para gerir o stock.',
      subtitle: 'Selecione uma loja para gerir o stock',
      goToStores: 'Ir para lojas',
    },
    summary: { low: 'Stock baixo', negative: 'Stock negativo', value: 'Valor estimado do stock' },
    status: { ok: 'Em stock', low: 'Baixo', out: 'Esgotado', negative: 'Negativo' },
    overview: {
      search: 'Pesquisar produtos',
      product: 'Produto',
      onHand: 'Em stock',
      status: 'Estado',
      lastCost: 'Último custo',
      noCost: '—',
      empty: 'Sem produtos para mostrar.',
    },
    purchases: {
      record: 'Registar compra',
      recordTitle: 'Registar compra',
      detailsTitle: 'Compra',
      date: 'Data',
      supplier: 'Fornecedor',
      newSupplier: 'Novo fornecedor',
      noSupplier: 'Sem fornecedor',
      invoice: 'Referência da fatura',
      paymentMethod: 'Método de pagamento',
      vatAmount: 'Valor de IVA',
      vatRate: 'Taxa de IVA (%)',
      vatRateHelp: 'Incluído no custo por embalagem.',
      notes: 'Notas',
      lines: 'Linhas',
      product: 'Produto',
      newProduct: 'Novo produto',
      newProductName: 'Nome do produto',
      packageQuantity: 'Embalagens recebidas',
      unitCost: 'Custo por embalagem',
      total: 'Total',
      addLine: 'Adicionar linha',
      removeLine: 'Remover linha',
      status: 'Estado',
      view: 'Ver',
      void: 'Anular compra',
      voidTitle: 'Anular esta compra?',
      voidMessage: 'O stock e a despesa associada são revertidos. Esta ação não pode ser desfeita.',
      voidReason: 'Anulada no stock',
      voided: 'Compra anulada.',
      saved: 'Compra registada.',
      empty: 'Ainda não há compras.',
      negativeWarning: 'Estes produtos ficaram negativos: {{products}}',
    },
    purchaseStatus: { Recorded: 'Registada', Voided: 'Anulada' },
    movements: {
      type: 'Tipo',
      allTypes: 'Todos os tipos',
      when: 'Quando',
      product: 'Produto',
      delta: 'Variação',
      balance: 'Saldo',
      cost: 'Custo unitário',
      empty: 'Ainda não há movimentos.',
    },
    movementTypes: {
      OpeningBalance: 'Saldo inicial',
      Purchase: 'Compra',
      PurchaseVoid: 'Anulação de compra',
      Sale: 'Venda',
      SaleVoid: 'Anulação de venda',
      ServiceConsumption: 'Uso em serviço',
      ServiceConsumptionReversal: 'Uso em serviço revertido',
      Adjustment: 'Ajuste',
    },
    adjustments: {
      title: 'Retirar stock',
      intro: 'Os ajustes só retiram stock. Para aumentar o stock, registe uma compra.',
      open: 'Registar uma saída',
      save: 'Retirar stock',
      saved: 'Stock atualizado.',
      decreaseOnly: 'Pode retirar quantidade, ou indicar uma contagem que não ultrapasse o stock existente.',
      product: 'Produto',
      reason: 'Motivo',
      removed: 'Quantidade retirada',
      removedHelp: 'Embalagens retiradas do stock. Isto não adiciona stock.',
      counted: 'Embalagens contadas',
      countedHelp: 'Em stock: {{onHand}}. Uma contagem superior não é permitida.',
      amountReturned: 'Valor devolvido',
      amountReturnedHelp: 'Indique 0 se o fornecedor não devolveu dinheiro. Um valor superior reduz as despesas de inventário de hoje nesse montante.',
      refundPaymentMethod: 'Como foi devolvido',
      notes: 'Notas',
    },
    reasons: {
      CountCorrection: 'Correção de contagem',
      Damaged: 'Danificado',
      Expired: 'Expirado',
      InternalUse: 'Uso interno',
      Lost: 'Perdido',
      ReturnedToSupplier: 'Devolvido ao fornecedor',
      Other: 'Outro',
    },
    suppliers: {
      create: 'Adicionar fornecedor',
      createTitle: 'Novo fornecedor',
      editTitle: 'Editar fornecedor',
      edit: 'Editar',
      name: 'Nome',
      taxId: 'NIF',
      phone: 'Telefone',
      email: 'Email',
      notes: 'Notas',
      empty: 'Ainda não há fornecedores.',
      saved: 'Fornecedor guardado.',
      archive: 'Arquivar',
      archiveTitle: 'Arquivar fornecedor?',
      archiveMessage: 'Arquivar {{name}}? Mantém-se nas compras antigas.',
      archived: 'Fornecedor arquivado.',
      validation: { nameRequired: 'O nome do fornecedor é obrigatório.' },
    },
    validation: {
      productRequired: 'Escolha um produto.',
      reasonRequired: 'Escolha um motivo.',
      countInvalid: 'Indique a quantidade contada.',
      countExceedsOnHand: 'A contagem não pode ser superior ao stock existente.',
      countUnchanged: 'Essa contagem é igual ao stock existente.',
      quantityRemovedRequired: 'Indique a quantidade retirada.',
      quantityExceedsOnHand: 'Não pode retirar mais do que o stock existente.',
      amountReturnedInvalid: 'Indique 0 ou o valor que o fornecedor devolveu.',
      linesRequired: 'Adicione entre 1 e 100 linhas.',
      duplicateProduct: 'Cada produto só pode aparecer uma vez.',
      quantityRequired: 'A quantidade tem de ser maior que 0.',
      costRequired: 'Indique um custo de 0 ou mais.',
      dateRequired: 'Escolha uma data.',
      dateInFuture: 'A data não pode ser no futuro.',
      paymentMethodRequired: 'Escolha um método de pagamento na loja.',
      vatInvalid: 'O valor de IVA não pode ser negativo.',
      vatRateRequired: 'Indique uma taxa de IVA entre 0 e 100.',
    },
    errors: {
      load: 'Não foi possível carregar o stock.',
      adjust: 'Não foi possível atualizar o stock.',
      purchase: 'Não foi possível registar a compra.',
      voidPurchase: 'Não foi possível anular a compra.',
      supplier: 'Não foi possível guardar o fornecedor.',
      insufficient: 'Não há stock suficiente.',
      onlyNLeft: 'Só restam {{count}}.',
      notSellable: 'Este produto não é vendido a clientes.',
      unitLocked: 'A unidade não pode mudar depois de existirem movimentos.',
      purchaseNotFound: 'Compra não encontrada.',
      purchaseVoided: 'Esta compra já foi anulada.',
      supplierNotFound: 'Fornecedor não encontrado.',
      supplierArchived: 'Este fornecedor está arquivado.',
      recipeInvalid: 'A receita do serviço não é válida.',
    },
    recipe: {
      title: 'Produtos usados',
      product: 'Produto',
      quantity: 'Quantidade',
      add: 'Adicionar',
      remove: 'Remover produto',
      totalCost: 'Custo estimado dos produtos {{cost}}',
      costMissing: 'O custo fica incompleto até todas as linhas terem um custo de compra.',
      margin: 'Margem depois dos produtos {{amount}}',
    },
    usage: {
      title: 'Produtos usados',
      help: 'Preenchido a partir da receita do serviço. Use 0 para não consumir um produto.',
      toggle: 'Mostrar ou ocultar produtos usados',
    },
  },
};

const stockEs = {
  navigation: { stock: 'Stock' },
  roles: { modal: { form: { categories: { stock: 'Stock' } } } },
  dashboard: {
    kpis: {
      lowStock: 'Stock bajo',
      negativeStock: 'Stock negativo',
      stockValue: 'Valor del stock',
    },
  },
  productsManagement: {
    emptyHint: 'Registra una compra para añadir el primer producto al stock.',
    actions: {
      purchaseMore: 'Comprar más',
    },
    fields: {
      soldToCustomers: 'Vendido a clientes',
      soldToCustomersHelp: 'Desactívelo para productos de uso interno. No tienen precio para el cliente.',
      contentQuantity: 'Cantidad en cada envase',
      stockUnit: 'Unidad',
      contentLocked: 'El tamaño del envase queda bloqueado porque este producto ya tiene movimientos de stock.',
      lowStockThreshold: 'Aviso de stock bajo',
      lowStockHelp: 'Indique cuántos envases activan el aviso.',
      onHand: 'En stock',
      stockIncreasesOnPurchase: 'El stock solo aumenta cuando se registra una compra.',
      lastCost: 'Último coste {{cost}} el {{date}}',
      noCostYet: 'Aún sin coste de compra.',
    },
    units: { Unit: 'Unidad', Milliliter: 'Mililitro', Gram: 'Gramo' },
    card: { internalUse: 'Uso interno', onHand: 'En stock: {{quantity}}' },
    sale: { onlyNLeft: 'Solo quedan {{count}}' },
    validation: {
      contentRequired: 'El contenido del envase debe ser mayor que 0.',
      unitRequired: 'Elija una unidad.',
      lowStockInvalid: 'El aviso de stock bajo no puede ser negativo.',
    },
  },
  stock: {
    title: 'Stock',
    subtitle: 'Compras, movimientos y proveedores',
    tabs: {
      overview: 'Stock',
      stock: 'Stock',
      purchases: 'Compras',
      movements: 'Movimientos',
      adjustments: 'Ajustes',
      suppliers: 'Proveedores',
    },
    fallback: {
      message: 'Seleccione una tienda para gestionar el stock.',
      subtitle: 'Seleccione una tienda para gestionar el stock',
      goToStores: 'Ir a tiendas',
    },
    summary: { low: 'Stock bajo', negative: 'Stock negativo', value: 'Valor estimado del stock' },
    status: { ok: 'En stock', low: 'Bajo', out: 'Agotado', negative: 'Negativo' },
    overview: {
      search: 'Buscar productos',
      product: 'Producto',
      onHand: 'En stock',
      status: 'Estado',
      lastCost: 'Último coste',
      noCost: '—',
      empty: 'No hay productos para mostrar.',
    },
    purchases: {
      record: 'Registrar compra',
      recordTitle: 'Registrar compra',
      detailsTitle: 'Compra',
      date: 'Fecha',
      supplier: 'Proveedor',
      newSupplier: 'Nuevo proveedor',
      noSupplier: 'Sin proveedor',
      invoice: 'Referencia de factura',
      paymentMethod: 'Método de pago',
      vatAmount: 'Importe de IVA',
      vatRate: 'Tipo de IVA (%)',
      vatRateHelp: 'Incluido en el coste por envase.',
      notes: 'Notas',
      lines: 'Líneas',
      product: 'Producto',
      newProduct: 'Nuevo producto',
      newProductName: 'Nombre del producto',
      packageQuantity: 'Envases recibidos',
      unitCost: 'Coste por envase',
      total: 'Total',
      addLine: 'Añadir línea',
      removeLine: 'Quitar línea',
      status: 'Estado',
      view: 'Ver',
      void: 'Anular compra',
      voidTitle: '¿Anular esta compra?',
      voidMessage: 'El stock y el gasto vinculado se revierten. No se puede deshacer.',
      voidReason: 'Anulada desde stock',
      voided: 'Compra anulada.',
      saved: 'Compra registrada.',
      empty: 'Aún no hay compras.',
      negativeWarning: 'Estos productos han quedado en negativo: {{products}}',
    },
    purchaseStatus: { Recorded: 'Registrada', Voided: 'Anulada' },
    movements: {
      type: 'Tipo',
      allTypes: 'Todos los tipos',
      when: 'Cuándo',
      product: 'Producto',
      delta: 'Cambio',
      balance: 'Saldo',
      cost: 'Coste unitario',
      empty: 'Aún no hay movimientos.',
    },
    movementTypes: {
      OpeningBalance: 'Saldo inicial',
      Purchase: 'Compra',
      PurchaseVoid: 'Anulación de compra',
      Sale: 'Venta',
      SaleVoid: 'Anulación de venta',
      ServiceConsumption: 'Uso en servicio',
      ServiceConsumptionReversal: 'Uso en servicio revertido',
      Adjustment: 'Ajuste',
    },
    adjustments: {
      title: 'Retirar stock',
      intro: 'Los ajustes solo retiran stock. Para aumentarlo, registre una compra.',
      open: 'Registrar una salida',
      save: 'Retirar stock',
      saved: 'Stock actualizado.',
      decreaseOnly: 'Puede retirar cantidad, o indicar un recuento que no supere el stock disponible.',
      product: 'Producto',
      reason: 'Motivo',
      removed: 'Cantidad retirada',
      removedHelp: 'Envases retirados del stock. Esto no añade stock.',
      counted: 'Envases contados',
      countedHelp: 'En stock: {{onHand}}. Un recuento mayor no está permitido.',
      amountReturned: 'Importe devuelto',
      amountReturnedHelp: 'Indique 0 si el proveedor no devolvió dinero. Un importe mayor reduce los gastos de inventario de hoy en esa cantidad.',
      refundPaymentMethod: 'Cómo se devolvió',
      notes: 'Notas',
    },
    reasons: {
      CountCorrection: 'Corrección de recuento',
      Damaged: 'Dañado',
      Expired: 'Caducado',
      InternalUse: 'Uso interno',
      Lost: 'Perdido',
      ReturnedToSupplier: 'Devuelto al proveedor',
      Other: 'Otro',
    },
    suppliers: {
      create: 'Añadir proveedor',
      createTitle: 'Nuevo proveedor',
      editTitle: 'Editar proveedor',
      edit: 'Editar',
      name: 'Nombre',
      taxId: 'NIF',
      phone: 'Teléfono',
      email: 'Email',
      notes: 'Notas',
      empty: 'Aún no hay proveedores.',
      saved: 'Proveedor guardado.',
      archive: 'Archivar',
      archiveTitle: '¿Archivar proveedor?',
      archiveMessage: '¿Archivar {{name}}? Se mantiene en las compras anteriores.',
      archived: 'Proveedor archivado.',
      validation: { nameRequired: 'El nombre del proveedor es obligatorio.' },
    },
    validation: {
      productRequired: 'Elija un producto.',
      reasonRequired: 'Elija un motivo.',
      countInvalid: 'Indique la cantidad contada.',
      countExceedsOnHand: 'El recuento no puede ser mayor que el stock disponible.',
      countUnchanged: 'Ese recuento coincide con el stock disponible.',
      quantityRemovedRequired: 'Indique la cantidad retirada.',
      quantityExceedsOnHand: 'No puede retirar más que el stock disponible.',
      amountReturnedInvalid: 'Indique 0 o el importe que devolvió el proveedor.',
      linesRequired: 'Añada entre 1 y 100 líneas.',
      duplicateProduct: 'Cada producto solo puede aparecer una vez.',
      quantityRequired: 'La cantidad debe ser mayor que 0.',
      costRequired: 'Indique un coste de 0 o más.',
      dateRequired: 'Elija una fecha.',
      dateInFuture: 'La fecha no puede ser futura.',
      paymentMethodRequired: 'Elija un método de pago en tienda.',
      vatInvalid: 'El IVA no puede ser negativo.',
      vatRateRequired: 'Indique un tipo de IVA entre 0 y 100.',
    },
    errors: {
      load: 'No se pudo cargar el stock.',
      adjust: 'No se pudo actualizar el stock.',
      purchase: 'No se pudo registrar la compra.',
      voidPurchase: 'No se pudo anular la compra.',
      supplier: 'No se pudo guardar el proveedor.',
      insufficient: 'No hay stock suficiente.',
      onlyNLeft: 'Solo quedan {{count}}.',
      notSellable: 'Este producto no se vende a clientes.',
      unitLocked: 'La unidad no puede cambiar cuando ya hay movimientos.',
      purchaseNotFound: 'Compra no encontrada.',
      purchaseVoided: 'Esta compra ya está anulada.',
      supplierNotFound: 'Proveedor no encontrado.',
      supplierArchived: 'Este proveedor está archivado.',
      recipeInvalid: 'La receta del servicio no es válida.',
    },
    recipe: {
      title: 'Productos usados',
      product: 'Producto',
      quantity: 'Cantidad',
      add: 'Añadir',
      remove: 'Quitar producto',
      totalCost: 'Coste estimado de productos {{cost}}',
      costMissing: 'El coste está incompleto hasta que cada línea tenga un coste de compra.',
      margin: 'Margen después de productos {{amount}}',
    },
    usage: {
      title: 'Productos usados',
      help: 'Rellenado desde la receta del servicio. Use 0 para no consumir un producto.',
      toggle: 'Mostrar u ocultar productos usados',
    },
  },
};

export const stockTranslationsEn = stockEn;
export const stockTranslationsPt = stockPt;
export const stockTranslationsEs = stockEs;
